module.exports = __webpack_public_path__ + "assets/img/header_copy_pc.3a6da3de.svg";